<template>
  <div v-click-outside="hideMenus" class="navbar">
    <transition name="fade" mode="out-in">
      <profile-menu :navHeight="navHeight" v-if="activeMenus.isProfileMenu">
        <div @click="duplicateProfile" class="row py-2 px-3 pointer pm-item">
          Duplicar {{ kProfile.name }}
        </div>
        <div
          @click="toggleDeleteProfileMenu"
          class="row py-2 px-3 pointer pm-item"
        >
          Eliminar {{ kProfile.name }}
        </div>
        <div
          v-if="kProfile.plan"
          @click="togglePauseMenu"
          class="row py-2 px-3 pointer pm-item"
        >
          Pausar plan a {{ kProfile.name }}
        </div>
        <div
          v-if="kProfile.plan == null"
          @click="$router.push('/plans/?steps=grid') && hideMenus()"
          class="row py-2 px-3 pointer pm-item"
        >
          Añadir plan a {{ kProfile.name }}
        </div>
        <div
          @click="refProfile"
          class="row py-2 px-3 text-alert pointer pm-item"
        >
          2 días gratis x referenciar
        </div>
        <div class="border-top my-2"></div>
        <div @click="logOut" class="row py-2 px-3 pointer pm-item">
          Cerrar sesión
        </div>
        <div class="row p-2 pointer">
          <whatsapp-Button
            :phone="company_data.client_service"
            :text="'Hola,necesito ayuda con la gestion de mis perfiles'"
            :buttonlabel="'Ayuda'"
            :buttonClass="'menu-link'"
          />
        </div>
      </profile-menu>
    </transition>
    <transition name="fade" mode="out-in">
      <profile-menu :navHeight="navHeight" v-if="activeMenus.isPauseMenu">
        <h1 class="mb-0">Pausar Plan</h1>
        <p class="subtext text-alert">¿CUANTOS DÍAS VAS A PAUSARLO?</p>
        <select class="w-75 mb-3" ref="days" name="days" id="days">
          <option value="1">1 día</option>
          <option value="2">2 días</option>
          <option value="3">3 días</option>
          <option value="4">4 días</option>
          <option value="5">5 días</option>
          <option value="6">6 días</option>
          <option value="7">7 días</option>
        </select>
        <p class="mt-0">
          Una vez pauses el plan no podrás reanudar antes de los días que
          escojas
        </p>
        <button class="bg-accent mb-3" @click="planPause">Pausar Plan</button>
      </profile-menu>
      <profile-menu
        :navHeight="navHeight"
        v-if="activeMenus.isDeleteProfileMenu"
        class="pb-5 pt-4"
      >
        <h3 class="mb-0 text-rem-1-75">Eliminar perfil</h3>
        <p class="subtext text-alert-red mt-1 mb-4 pb-2">
          ¿ESTÁS SEGURO DE ELIMINAR TU PERFIL?
        </p>
        <div class="px-3 w-100 mx-auto mb-5 mt-4">
          <button class="outlined-grey" @click="deleteProfile">
            Si, quiero eliminarlo
          </button>
        </div>
        <p class="mt-5 text-rem-0-7 text-grey-dark pt-3 pb-4">
          Una vez eliminado no<br />
          podrás recuperarlo
        </p>
      </profile-menu>

      <profile-menu
        :navHeight="navHeight"
        v-if="activeMenus.isDeleteAccountMenu"
        class="pb-5 pt-4"
      >
        <h3 class="mb-0 text-rem-1-75">Eliminar cuenta</h3>
        <p class="subtext text-alert-red mt-1 mb-4 pb-2 text-uppercase">
          ¿Estás seguro de eliminar tu cuenta?
        </p>
        <div class="px-3 w-100 mx-auto mb-5 mt-4">
          <button class="outlined-grey" @click="deleteAccount">
            Si, quiero eliminarla
          </button>
        </div>
        <p class="mt-5 text-rem-0-7 text-grey-dark pt-3 pb-4">
          Una vez eliminada no<br />podrás acceder
        </p>
      </profile-menu>
    </transition>

    <transition-expand>
      <div
        v-if="
          alert &&
            logged &&
            ($route.query.welcome == 'false' || !$route.query.welcome) &&
            $route.path == '/'
        "
        class="container-fluid d-flex"
        :style="alertStyle"
      >
        <div
          :style="'height: ' + alertStyle.height"
          class="d-flex align-items-center w-100"
        >
          <div class="d-flex align-items-center py-1 w-100">
            <p class="my-0 text-left px-2 text-rem-0-9 text-md-center w-100">
              {{ alertMessage }}
            </p>
          </div>
          <div
            v-if="kProfile.status !== 'pending'"
            class="d-flex align-items-center ml-auto"
            @click="hideAlert()"
          >
            <img
              src="@/assets/images/icons/close.svg"
              height="12"
              alt="Close alert"
            />
          </div>
        </div>
      </div>
    </transition-expand>
    <div
      v-if="$route.query.welcome == 'false' || !$route.query.welcome"
      class="container-fluid align-items-center d-flex nav"
      :style="navStyle"
    >
      <transition name="fade-nav" mode="out-in">
        <div
          class="d-flex w-100 justify-content-center"
          v-if="logged && $route.path.length > 1"
        >
          <a
            class="position-absolute back-arrow d-flex align-content-center mr-auto pointer"
            @click="toggleShow && $router.go(-1) && goBack()"
          >
            <img
              class="my-auto"
              src="@/assets/images/icons/back-arrow.svg"
              height="15"
              alt="Go back to menu"
            />
          </a>
          <p class="my-0 text-rem-1-1 text-capitalize poppins-medium">
            {{
              $route.query.navbarT
                ? $route.query.navbarT
                : extraInfo && extraInfo.step_title
                ? extraInfo.step_title.header
                : ""
            }}
          </p>
          <a
            class="position-absolute home-icon d-flex align-content-center mr-auto pointer"
            @click="toggleShow && $router.push('/')"
            v-if="$route.params.param0 == 'plans'"
          >
            <img
              class="my-auto"
              src="@/assets/images/icons/home-solid.svg"
              height="17"
              alt="Go back to home"
            />
          </a>
        </div>
        <multiselect
          ref="multiselect"
          v-if="logged && kProfile && kProfile._id && $route.path.length < 2"
          v-model="kProfile"
          placeholder="Perfil"
          label="_id"
          track-by="_id"
          :options="user.profiles"
          :option-height="104"
          :show-labels="false"
          openDirection="below"
          :searchable="false"
          :key="kProfile._id"
          @open="toggleAccountMenu"
          @close="hideMenus"
          @select="changeKprofile"
        >
          <template slot="singleLabel" slot-scope="props">
            <div class="option__image_wrapper">
              <transition name="fade" mode="out-in">
                <img
                  v-if="props.option.portfolio"
                  v-show="imgLoaded"
                  v-on:load="imgLoaded = true"
                  class="option__image"
                  :src="
                    props.option.portfolio == undefined
                      ? ''
                      : `https://69prepagos.com/${props.option.portfolio[0].id}_360@2x.jpg`
                  "
                  alt="Active profile picture"
                />
              </transition>
            </div>
            <span class="option__desc">
              <span class="option__title">{{ props.option.name }}</span>
            </span>
          </template>
          <template slot="option" slot-scope="props">
            <img
              v-if="props.option.portfolio"
              class="option__image"
              :src="
                props.option.portfolio == undefined
                  ? ''
                  : `https://69prepagos.com/${props.option.portfolio[0].id}_360@2x.jpg`
              "
              :alt="
                'Profile pictur of ' +
                  props.option.name +
                  ' ' +
                  props.option._id
              "
            />
            <div class="option__desc">
              <span class="option__title"
                >{{ props.option.name }}, {{ props.option.age }}</span
              >
              <span class="option__small"></span>
            </div>
          </template>
          <template slot="afterList">
            <div
              @click="newProfile"
              class="new-profile-wrapper after pt-2 pb-3 d-flex align-items-center"
            >
              <img
                src="@/assets/images/icons/new-profile.svg"
                height="24"
                alt="Add new profile"
              />
              <div class="new-profile">Nuevo Perfil</div>
            </div>
            <div class="container-fluid after mt-auto border-top pt-2">
              <div @click="toggleDeleteAccountMenu" class="row p-2 pointer">
                Eliminar Cuenta
              </div>
              <div class="row pointer text-left">
                <whatsapp-Button
                  :phone="company_data.client_service"
                  :text="'Hola,necesito ayuda con la gestion de mis perfiles'"
                  :buttonlabel="'Ayuda'"
                  :buttonClass="'menu-link'"
                />
              </div>
              <div class="row p-2 pointer">
                <div
                  @click="logOut"
                  class="px-0 flex-row d-flex align-items-center"
                >
                  <img
                    src="@/assets/images/icons/logout.svg"
                    height="16"
                    alt="Add new profile"
                    class="mr-2"
                  />
                  Cerrar sesión
                </div>
              </div>
            </div>
          </template>
        </multiselect>
      </transition>

      <div
        v-if="this.logged"
        class="d-flex align-items-center ml-auto py-2 px-1 pointer"
        @click="toggleProfileMenu()"
      >
        <img
          src="@/assets/images/icons/settings.svg"
          height="13"
          alt="Profile menu"
        />
      </div>
    </div>
  </div>
</template>

<script>
import settings from "@/api/settings"
import TransitionExpand from "@/components/Utils/TransitionExpand.vue"
import WhatsappButton from "@/components/UI/WhatsappButton.vue"
import Multiselect from "vue-multiselect"
import ClickOutside from "vue-click-outside"
import ProfileMenu from "@/components/UI/Partials/ProfileMenu.vue"

import { mapGetters, mapActions } from "vuex"
export default {
  props: ["navHeight"],
  data() {
    return {
      company_data: settings.company_data,
      alertMessage: "Tu perfil está en revisión",
      imgLoaded: false,
      isLoading: false,
    }
  },
  components: {
    WhatsappButton,
    TransitionExpand,
    Multiselect,
    ProfileMenu,
  },
  computed: {
    ...mapGetters([
      "navStyle",
      "alertStyle",
      "logged",
      "user",
      "colorScheme",
      "alert",
      "activeMenus",
      "modalPlaceHolder",
      "kProfile",
    ]),
    extraInfo() {
      return this.$store.getters[`${this.$route.params.param0}_extraInfo`]
    },
    isActiveMenus() {
      return Object.values(this.activeMenus).indexOf(true) >= 0
    },
  },
  watch: {
    //para actualizar componente en cambio de ruta
    $route(to /*, from*/) {
      console.log("ENTRE AL TO DE NAV", to)
      this.imgLoaded = false
      //const routerParameter = to.params.param0
      if (/* routerParameter, */ to.path !== "/") {
        console.log("LLENDO A UNA SECCION")
        this.SET_NAVSTYLE({
          ...this.navStyle,
          backgroundColor: "white",
          color: this.colorScheme.dark,
          boxShadow: "0 3px 6px 0 rgba(0,0,0,0.15)",
        })
      } else {
        console.log("LLENDO AL MENU")
        if (!this.logged == false) {
          document.documentElement.style.overflow = "auto"
          const kProfile = this.user.profiles.filter(profile => {
            return profile._id == this.user.kProfile
          })
          console.log("GETTED KPROFILE", kProfile[0])
          this.kProfile = kProfile[0]
          this.SET_NAVSTYLE({
            ...this.navStyle,
            backgroundColor: this.colorScheme.accent,
            color: "white",
            boxShadow: "none",
          })
        } else {
          this.SET_NAVSTYLE({
            ...this.navStyle,
            backgroundColor: "transparent",
            color: "white",
            boxShadow: "none",
          })
        }
      }
    },
    kProfile() {
      if (
        this.kProfile &&
        this.kProfile.status &&
        this.kProfile.status == "pending"
      ) {
        this.showAlert()
      }
    },
  },
  methods: {
    ...mapActions([
      "SET_ALERTSTYLE",
      "CHANGE_K_PROFILE",
      "SET_NAVSTYLE",
      "LOG_OUT",
      "DUPLICATE_PROFILE",
      "DELETE_PROFILE",
      "NEW_PROFILE",
      "SET_GENERAL_ERROR",
      "SET_IS_LOADING",
      "PAUSE_PLAN",
      "CHANGE_ALERT",
      "DELETE_ACCOUNT",
      "SET_ACTIVE_ALERT",
      "SET_ACTIVE_MENUS",
      "TOGGLE_MODAL_PLACEHOLDER",
      "INIT_APP",
    ]),
    changeKprofile(option) {
      console.log("PARA CAMBIAR K PROFILE", option)
      this.CHANGE_K_PROFILE(option._id).then(state => {
        if (state == true) {
          if (option.status == "pending") {
            this.showAlert()
          } else {
            this.hideAlert()
          }
        }
      })
    },
    showAlert() {
      this.CHANGE_ALERT(true)
      this.SET_ALERTSTYLE({
        ...this.alertStyle,
        height: "40px",
      })
    },
    hideAlert() {
      console.log("HIDE ALERT TRIGGERED")
      this.CHANGE_ALERT(false)
      this.SET_ALERTSTYLE({
        ...this.alertStyle,
        height: "0px",
      })
    },
    refProfile() {
      this.hideMenus()
      this.SET_ACTIVE_ALERT({
        type: "ref",
        title: "Referencia & gana",
        message:
          "Invita a tus amigas a que prueben prepago69.com <br/><br/>Por cada perfil que quede activo en el listado te <b>regalamos 2 días de publicidad.</b>",
        classes: "bg-white",
        textClasses: "text-grey-dark-80",
        status: true,
        to: {
          path: "/",
          query: null,
        },
      })
      console.log('TO IMPLEMENT REFFFFFFFS"')
    },
    deleteAccount() {
      this.SET_IS_LOADING(true)
      this.hideMenus()
      this.SET_NAVSTYLE({
        ...this.navStyle,
        backgroundColor: "transparent",
        color: "white",
        boxShadow: "none",
      })
      this.DELETE_ACCOUNT({ sure: true }).then(resp => {
        if (resp) {
          this.LOG_OUT()
          this.SET_IS_LOADING(false)
        } else {
          this.SET_GENERAL_ERROR(true)
          this.SET_IS_LOADING(false)
        }
      })
    },
    newProfile() {
      this.SET_IS_LOADING(true)
      this.hideMenus()
      this.hideAlert()

      this.CHANGE_ALERT(!this.alert)
      this.NEW_PROFILE().then(resp => {
        if (resp) {
          this.$router.push("/profile")
          this.SET_IS_LOADING(false)
        } else {
          this.SET_GENERAL_ERROR(true)
          this.SET_IS_LOADING(false)
        }
      })
    },
    logOut() {
      console.log("LogOut")
      this.hideAlert()
      this.hideMenus()
      this.LOG_OUT()
      this.SET_NAVSTYLE({
        ...this.navStyle,
        backgroundColor: "transparent",
        color: "white",
        boxShadow: "none",
      })
    },
    deleteProfile() {
      this.SET_IS_LOADING(true)
      this.hideMenus()
      this.hideAlert()
      this.DELETE_PROFILE().then(message => {
        console.log("DELETEING ACCOUNT", message)
        if (message == true) {
          this.SET_IS_LOADING(false)
        } else {
          this.SET_GENERAL_ERROR(true)
          this.SET_IS_LOADING(false)
        }
      })
      /* this.SET_NAVSTYLE({
        ...this.navStyle,
        backgroundColor: "transparent",
        color: "white",
        boxShadow: "none",
      }) */
      /* this.isProfileMenu = false
      this.isProfileSubMenu = true */
    },
    planPause() {
      this.SET_IS_LOADING(true)
      this.hideMenus()
      console.log("ESTSOS SON LOS DIASS", this.$refs.days.value)
      this.PAUSE_PLAN(this.$refs.days.value).then(message => {
        console.log("DELETEING ACCOUNT", message)
        if (message == true) {
          this.INIT_APP().then(() => {
            this.SET_IS_LOADING(false)
          })
        } else {
          this.SET_GENERAL_ERROR(true)
          this.SET_IS_LOADING(false)
        }
      })
    },
    duplicateProfile() {
      this.SET_IS_LOADING(true)
      this.hideMenus()
      this.DUPLICATE_PROFILE().then(message => {
        if (message == true) {
          this.SET_IS_LOADING(false)
        } else {
          this.SET_GENERAL_ERROR(true)
          this.SET_IS_LOADING(false)
        }
      })
    },
    toggleShow() {
      console.log("toggle")
      this.imgLoaded = true
    },
    toggleAccountMenu() {
      /* if (this.isActiveMenus && this.activeMenus.isProfileMenu) { */
      console.log("toggle", this.activeMenus.isAccountMenu)
      this.SET_ACTIVE_MENUS({
        isAccountMenu: !this.activeMenus.isAccountMenu,
        isPauseMenu: false,
        isProfileSubMenu: false,
        isDeleteProfileMenu: false,
        isDeleteAccountMenu: false,
        isProfileMenu: false,
      }).then(status => {
        console.log("toggle", status, this.activeMenus.isAccountMenu)
      })
      /* } else {
        console.log("toggle", this.activeMenus.isAccountMenu)
        this.SET_ACTIVE_MENUS({
          ...this.activeMenus,
          isAccountMenu: !this.activeMenus.isAccountMenu,
        }).then(status => {
          console.log("toggle", status, this.activeMenus.isAccountMenu)
        })
      } */
    },
    toggleProfileMenu() {
      console.log("toggle", this.activeMenus.isProfileMenu)
      this.SET_ACTIVE_MENUS({
        isAccountMenu: false,
        isPauseMenu: false,
        isProfileSubMenu: false,
        isDeleteProfileMenu: false,
        isDeleteAccountMenu: false,
        isProfileMenu: !this.activeMenus.isProfileMenu,
      }).then(status => {
        console.log("toggle", status, this.activeMenus.isProfileMenu)
      })
    },
    togglePauseMenu() {
      console.log("toggle")
      this.SET_ACTIVE_MENUS({
        isAccountMenu: false,
        isPauseMenu: !this.activeMenus.isPauseMenu,
        isProfileSubMenu: false,
        isDeleteProfileMenu: false,
        isDeleteAccountMenu: false,
        isProfileMenu: false,
      })
    },
    toggleDeleteProfileMenu() {
      console.log("toggle")
      this.SET_ACTIVE_MENUS({
        isAccountMenu: false,
        isPauseMenu: false,
        isProfileSubMenu: false,
        isDeleteProfileMenu: !this.activeMenus.isDeleteProfileMenu,
        isDeleteAccountMenu: false,
        isProfileMenu: false,
      })
    },
    toggleDeleteAccountMenu() {
      console.log("toggle")
      this.$refs.multiselect.deactivate()
      this.SET_ACTIVE_MENUS({
        isAccountMenu: false,
        isPauseMenu: false,
        isProfileSubMenu: false,
        isDeleteProfileMenu: false,
        isDeleteAccountMenu: !this.activeMenus.isDeleteAccountMenu,
        isProfileMenu: false,
      })
    },
    /* toggleAccountMenu() {
      console.log("toggle")
      this.SET_ACTIVE_MENUS({
        isPauseMenu: false,
        isProfileSubMenu: false,
        isDeleteProfileMenu: false,
        isDeleteAccountMenu: false,
        isProfileMenu: false,
        isAccountMenu: !this.activeMenus.isAccountMenu,
      })
    }, */
    hideProfileMenu() {
      console.log("hide")
      this.SET_ACTIVE_MENUS({
        ...this.activeMenus,
        isProfileMenu: false,
      })
    },
    hideProfileSubMenu() {
      console.log("hide")
      this.SET_ACTIVE_MENUS({
        ...this.activeMenus,
        isProfileSubMenu: false,
      })
    },
    hidePauseMenu() {
      console.log("hide")
      this.SET_ACTIVE_MENUS({
        ...this.activeMenus,
        isPauseMenu: false,
      })
    },
    hideMenus() {
      if (this.$refs.multiselect) {
        this.$refs.multiselect.deactivate()
      }
      console.log("hide all")
      this.SET_ACTIVE_MENUS({
        isAccountMenu: false,
        isPauseMenu: false,
        isProfileSubMenu: false,
        isDeleteProfileMenu: false,
        isDeleteAccountMenu: false,
        isProfileMenu: false,
      })
    },
    goBack() {
      document.documentElement.style.overflow = "auto"
    },
  },
  mounted() {
    console.log("navMontado")
  },
  directives: {
    ClickOutside,
  },
}
</script>

<style lang="scss" scope>
@import "~@/assets/styles/navBar.scss";
</style>
